import {
  AllowedIdsByEntityTypeInLoanChangesHistory,
  LoanChangesHistoryFieldType,
} from 'constants/loanChanges';

// A loan-changes-history field shows (and counts as a change) unless it is a technical ID the user
// never edits — the entity's own primary/foreign keys an EntityAdded operation records as Direct
// properties. A few foreign keys the user does pick are allowlisted per entity type.
export const checkIsFieldDisplayed = ({ type, rootEntityTypeName, propertyName }) => {
  const isIdType = type === LoanChangesHistoryFieldType.ID;
  const isAllowedPropertyName =
    AllowedIdsByEntityTypeInLoanChangesHistory[rootEntityTypeName]?.includes(propertyName);

  return !isIdType || isAllowedPropertyName;
};
